export const environment = {
  production: true,
  LOCALIZATION_API_URL: '##{LOCALIZATION_API_BASE_URL}##'
};